// src/Components/SideBarNav/NavItem.tsx
import { NavLink } from 'react-router-dom';
import { ArrowDownIcon } from 'assets/icons';

export interface INavItemProps {
  name: string;
  path: string;
  suffix?: React.ReactNode;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  isExpanded?: boolean;
  showArrow?: boolean;
  isDropdownToggle?: boolean; // New prop to identify dropdown toggles
}

export default function NavItem(props: INavItemProps) {
  const {
    name,
    path,
    icon: Icon,
    suffix,
    className,
    onClick,
    isExpanded,
    showArrow,
    isDropdownToggle, // Receive the new prop
  } = props;

  return (
    <nav className={className}>
      <NavLink
        to={path}
        onClick={onClick}
        className={({ isActive }) =>
          // Apply the active class only if it's not a dropdown toggle
          !isDropdownToggle && isActive
            ? 'active flex items-center px-3 py-1.5 rounded-md'
            : 'flex items-center px-3 py-1.5 rounded-md'
        }
      >
        <Icon className="w-4 h-4" />
        <span className="ml-2 text-xs font-bold">{name}</span>
        {showArrow && (
          <span
            className={`ml-auto transform transition-transform ${
              isExpanded ? 'rotate-180' : 'rotate-0'
            }`}
          >
            <ArrowDownIcon className="w-4 h-4" />
          </span>
        )}
        {suffix && <div className="ml-2 text-xs">{suffix}</div>}
      </NavLink>
    </nav>
  );
}
